export const A1a_ID = 1
export const A1b_ID = 2
export const A1c_ID = 3
export const A1d_ID = 4
export const A1e_ID = 5
export const B1_ID = 6
export const B2_ID = 7
export const B3a_ID = 8
export const B3b_ID = 9
export const B3c_ID = 10
export const B4_ID = 11
export const C_ID = 12
export const D1a_ID = 13
export const D1b_ID = 14
export const D2_ID = 15
export const D3_ID = 16
export const E_ID = 17

export const kbaCriteria = [
  {id: A1a_ID, name: 'A1a'},
  {id: A1b_ID, name: 'A1b'},
  {id: A1c_ID, name: 'A1c'},
  {id: A1d_ID, name: 'A1d'},
  {id: A1e_ID, name: 'A1e'},
  {id: B1_ID, name: 'B1'},
  {id: B2_ID, name: 'B2'},
  {id: B3a_ID, name: 'B3a'},
  {id: B3b_ID, name: 'B3b'},
  {id: B3c_ID, name: 'B3c'},
  {id: B4_ID, name: 'B4'},
  {id: C_ID, name: 'C'},
  {id: D1a_ID, name: 'D1a'},
  {id: D1b_ID, name: 'D1b'},
  {id: D2_ID, name: 'D2'},
  {id: D3_ID, name: 'D3'},
  {id: E_ID, name: 'E'}
]
